// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1e407","row":"ProcedureTreatmentSummary_row__TBAgh"};